import './ParticipantSidebar.css';

const AVATAR_COLORS = ['#667eea', '#10b981', '#ef4444', '#f59e0b', '#8b5cf6', '#ec4899', '#3b82f6', '#14b8a6'];

function avatarColor(name) {
  let hash = 0;
  for (const c of name) hash = (hash * 31 + c.charCodeAt(0)) & 0xffffffff;
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

export default function ParticipantSidebar({ participants, cards, currentUser }) {
  const activeAuthors = new Set(cards.map((c) => c.author));

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <span className="sidebar-title">Participants</span>
        <span className="sidebar-count">{participants.length}</span>
      </div>
      <ul className="participant-list">
        {participants.map((p) => (
          <li key={p.id} className={`participant ${p.name === currentUser ? 'participant--you' : ''}`}>
            <span className="participant-avatar" style={{ background: avatarColor(p.name) }}>
              {p.name[0].toUpperCase()}
            </span>
            <span className="participant-name">
              {p.name}
              {p.name === currentUser && <span className="participant-you">you</span>}
            </span>
            {activeAuthors.has(p.name) && (
              <span className="participant-active" title="Has added cards" />
            )}
          </li>
        ))}
        {participants.length === 0 && (
          <li className="participant-empty">No one has joined yet</li>
        )}
      </ul>
    </aside>
  );
}
